import { IMacro } from '../../../hooks/macrosPage/useMacroList';
import { PlaceholdersOnCommentAction } from '../../../hooks/macrosPage/usePlaceholderListOnCommentAction';
import { ticketInteractionViewOptionsMap, ticketInteractionViewViewType } from '../../../model/types';
import { TicketFieldPlaceholderKey } from '../../../store/childStore/macroStore';
import {
    generateTicketFormNameForStorage,
    getNewTicketKeyFromUrl,
    getTicketKeyFromUrl
} from '../../../store/childStore/tabStore';
import { grispiNotification } from '../../../store/useNotificationStore';
import getStore from '../../../utils/store/getStore';
import { fireInsertTextToRichTextEditorStateEvent } from '../../GrispiRichTextEditor/plugins/InsertTextPlugin';

function interpolateComment(comment: string) {
    // TODO cagri:
    // @PlaceholdersOnCommentAction is hardoced currently, should change with all possible placeholderKeys or placeholderKeys on store
    return Object.keys(PlaceholdersOnCommentAction).reduce(
        (acc, placeholderkey: TicketFieldPlaceholderKey) =>
            acc.replaceAll(
                `{{${placeholderkey}}}`,
                getStore().MacroStore.getPlaceholderValue(placeholderkey)?.toString() ?? ''
            ),
        comment
    );
}

function handleOnSelect(macro: IMacro, errorText: string, viewType: ticketInteractionViewViewType): void {
    if (!macro?.actions) {
        grispiNotification('info', errorText, 'info');
        return;
    }

    const eventListenerKey = generateTicketFormNameForStorage(
        getTicketKeyFromUrl(window.location.href) || getNewTicketKeyFromUrl(window.location.href)
    );

    macro.actions.forEach((action) => {
        if (action.actionType === 'COMMENT') {
            fireInsertTextToRichTextEditorStateEvent({
                eventListenerKey:
                    viewType === ticketInteractionViewOptionsMap.chat
                        ? `chat-input-${eventListenerKey}`
                        : eventListenerKey,
                textToInsert: interpolateComment(action.value)
            });
        }
    });
}

export { handleOnSelect };
